import Platform from "../../../../libs/utility/Platform";
import { Theme } from "../../../components/constants";

export default {
    container: {
        width: "62%",
        height:"calc(100vh - 60px)"
    },
    heading: {
        marginLeft: "30px"
    },
    basicCard: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "10px",
        width: Platform.isMobileView() ? "100%" : "373px",
        height: "auto",
        position: "relative",
        padding: "15px",
        minHeight: "19px",
        maxHeight: "fit-content",
        maxWidth: "330px",
        cursor: "pointer",
    },
    cardContent: {
        width: "90%",
        height: "100%"
    },
    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 998,
    },
    cardsGroupWrapper:{
        position:"relative"
    },
    cardsGroupContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "20px",
        margin: "20px 0px",
        padding: "10px",
        overflowY: "auto",
        height: "65vh",
        scrollBehavior: "smooth",
    },
    popupChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "hidden",
        display: "flex",
        flexDirection: "column"
    },
    cardLabel: {
        fontWeight: 400,
        fontSize: "15px",
        lineHeight: "24px",
        color: Theme.TEXT_PRIMARY_BLACK,
        paddingY: "10px",
    },
    drawerContent: {
        height: "80%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        alignItems: "center",
    },
    customPopupHeaderStyles:{
        padding: "10px 20px"
    },
    scrollDownButton: {
        background: Theme.PRIMARY,
        width: "35px",
        height: "35px",
        borderRadius: "50%",
        cursor: "pointer",
        boxShadow: "rgba(0, 0, 0, 0.5) 5px 5px 10px",
        position: 'absolute',
        bottom: "10px",
        right: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
}